// ==========================================
// Returns the inventory of a product/variant
// ==========================================
export default function getInventory(product, variant){

    //Both products and variants should always have a inventory property.

    if(product || variant){

        // PRODUCT IS NOT A VARIANT
        if(variant === undefined)
            return product.inventory ? parseInt(product.inventory, 10) : product.inventory;
        
        // PRODUCT IS A VARIANT
        else
            return variant.inventory ? parseInt(variant.inventory, 10) : variant.inventory;

    }

}


// WEBPACK FOOTER //
// ./src/utils/inventoryUtils.js